export function formatSentenceCase(str = "") {
  if (!str) return "";

  // Mots à garder tels quels
  const acronyms = ["USB", "TV", "PC", "LED", "HD", "WIFI"];

  const words = str.split(" ").map((w) => {
    if (acronyms.includes(w.toUpperCase())) return w.toUpperCase();
    return w.toLowerCase();
  });

  const full = words.join(" ");

  return full.charAt(0).toUpperCase() + full.slice(1);
}
